import { createClient } from '@supabase/supabase-js';

const supabaseUrl = 'https://uxmqohylzxjwxpcfhvwb.supabase.co';
const supabaseKey = 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6InV4bXFvaHlsenhqd3hwY2ZodndiIiwicm9sZSI6ImFub24iLCJpYXQiOjE3NDQ0NTk4NzYsImV4cCI6MjA2MDAzNTg3Nn0.5gz3aJFViPwsB55c3A4sfDUD1nRZJmF7zoozD4ehw6w';
const supabase = createClient(supabaseUrl, supabaseKey);

export default supabase;
